'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _elementConstants = require('../../../common/elements/elementConstants');

exports.default = function (currentSize, sizeChange, minWidth) {
    return Math.max((currentSize || _elementConstants.ELEMENT_DEFAULT_WIDTH) + sizeChange, minWidth);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/resizing/calculateElementSize.js
// module id = 742
// module chunks = 0